var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { EventTypes } from '../events';
import transformEventType from './transformEventType';
/*
 * Takes a config mapper and create a middleware that will map over loaded configuration objects.
 */

export default (function (f) {
  return transformEventType(EventTypes.CHILDREN_CONFIG_LOADED)(function (evt, store) {
    var module = evt.module;

    if (module) {
      return _extends({}, evt, {
        module: f(module, store)
      });
    } else {
      return evt;
    }
  });
});